import { render, staticRenderFns } from "./Idcardauth.vue?vue&type=template&id=3051ff9c&scoped=true"
import script from "./Idcardauth.vue?vue&type=script&lang=js"
export * from "./Idcardauth.vue?vue&type=script&lang=js"
import style0 from "./Idcardauth.vue?vue&type=style&index=0&id=3051ff9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051ff9c",
  null
  
)

export default component.exports